import {
  LoomSiteAriResourceOwner,
  LoomSiteAriResourceType
} from "./chunk-T5DWCQIN.mjs";
import {
  RegisteredAri
} from "./chunk-YG2E6ZVD.mjs";
import {
  AriParser
} from "./chunk-Q7FABYST.mjs";

// src/loom/site/manifest.ts
var loomSiteAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: LoomSiteAriResourceOwner,
  resourceType: LoomSiteAriResourceType,
  resourceIdSlug: "{siteId}",
  resourceIdSegmentFormats: {
    siteId: /[a-zA-Z0-9_\-.]{1,255}/
    // eslint-disable-line no-useless-escape
  }
};

// src/loom/site/index.ts
var LoomSiteAri = class _LoomSiteAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.resourceIdSegmentValues.siteId;
  }
  get siteId() {
    return this._siteId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: loomSiteAriStaticOpts.qualifier,
      platformQualifier: loomSiteAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: loomSiteAriStaticOpts.resourceOwner,
      resourceType: loomSiteAriStaticOpts.resourceType,
      resourceId: `${opts.siteId}`,
      resourceIdSegmentValues: {
        siteId: opts.siteId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, loomSiteAriStaticOpts);
    return new _LoomSiteAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, loomSiteAriStaticOpts);
    return new _LoomSiteAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId
    };
  }
};

export {
  LoomSiteAri
};
